// revdeco-card-dots.js — ronds de couleurs sur les cartes produit des rayons
// (retour Denis 2026-08-04 : on ne voit pas les coloris disponibles depuis la liste).
// Lit data-rdcolors="Nom|Nom|…" posé par product-card.liquid et peint des ronds
// via window.RD_COLOR_MAP (revdeco-color-map.js). Tri commercial : blanc, noir,
// marine, gris, bleu… d'abord. Survit aux mises à jour AJAX des filtres
// (MutationObserver).
(function () {
  'use strict';
  var FAM = ['blanc,white', 'noir,black', 'marine,navy', 'gris,grey,gray,anthracite', 'bleu,blue,royal', 'rouge,red,bordeaux', 'vert,green,kaki', 'jaune,yellow', 'orange', 'rose,pink', 'violet,purple', 'beige,marron,brown'];
  function prio(name) {
    var n = name.toLowerCase();
    for (var i = 0; i < FAM.length; i++) {
      var words = FAM[i].split(',');
      for (var j = 0; j < words.length; j++) if (n.indexOf(words[j]) !== -1) return i;
    }
    return 50;
  }
  var MAX = 6;
  function paint(el) {
    var map = window.RD_COLOR_MAP;
    if (!map) return;
    el.classList.add('rd-dots--done');
    var names = (el.getAttribute('data-rdcolors') || '').split('|').filter(Boolean);
    var total = parseInt(el.getAttribute('data-rdtotal') || names.length, 10);
    names.sort(function (a, b) { return prio(a) - prio(b) || a.localeCompare(b); });
    var html = '', shown = 0, seen = {};
    for (var i = 0; i < names.length && shown < MAX; i++) {
      var css = map[names[i]];
      if (!css) continue;
      // un rond par FAMILLE de couleur (pas trois blancs côte à côte)
      var fam = prio(names[i]);
      if (fam < 50 && seen[fam]) continue;
      seen[fam] = true;
      html += '<i title="' + names[i].replace(/"/g, '&quot;') + '" style="background:' + css + '"></i>';
      shown++;
    }
    if (!shown) return;
    if (total > shown) html += '<b>+' + (total - shown) + '</b>';
    el.innerHTML = html;
  }
  function scan(root) {
    (root.querySelectorAll ? root : document).querySelectorAll('.rd-dots[data-rdcolors]:not(.rd-dots--done)').forEach(paint);
  }
  function boot() {
    scan(document);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        if (muts[i].addedNodes.length) { scan(document); break; }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
